import React from 'react'
import { observer, PropTypes as MobxPropTypes } from 'mobx-react'
import { PropTypes } from 'prop-types'
import Checkbox from 'react-bootstrap/lib/Checkbox'

function TableItemCheckbox({ store, id }) {
  const checked = store.itemStore.isSelected(id)

  function handleOnClick() {
    store.itemStore.toggleItem(id)
  }

  return (
    <Checkbox
      style={{ margin: 0 }}
      onClick={handleOnClick}
      checked={checked}
      readOnly
    />
  )
}

TableItemCheckbox.propTypes = {
  id: PropTypes.string.isRequired,
  store: MobxPropTypes.observableObject.isRequired,
}

export default observer(TableItemCheckbox)
